import { AlertSort, AlertView } from '@netfoundry-ui/shared/model';

/** The alert type frontdoor pushes to the alerting service for a client certificate near expiry. */
export const CLIENT_CERTIFICATE_EXPIRING = 'frontdoor.client-certificate.expiring';

/** The alert type frontdoor pushes to the alerting service for a server certificate near expiry. */
export const SERVER_CERTIFICATE_EXPIRING = 'frontdoor.server-certificate.expiring';

/** The alert types the FD sub-app shows. Alerting matches them exactly, so each one is the detector's `alertType`. */
export const FRONTDOOR_ALERT_TYPES: string[] = [
    CLIENT_CERTIFICATE_EXPIRING,
    SERVER_CERTIFICATE_EXPIRING,
    'identity.offline',
    'identity.flapping',
    'service.unreachable',
    'service.dial-latency',
    'service.dial-latency-drift',
];

/** Worst first, then the soonest to lapse: the order someone renewing certificates works through them. */
export const FRONTDOOR_ALERT_SORT: AlertSort[] = [
    { field: 'severity', direction: 'asc' },
    { field: 'firstAssertedAt', direction: 'desc' },
];

/** True for a client or a server certificate alert. */
export function isCertificateAlert(alert: AlertView): boolean {
    return alert.alertType === CLIENT_CERTIFICATE_EXPIRING || alert.alertType === SERVER_CERTIFICATE_EXPIRING;
}

/** The id of the certificate a certificate alert is about. Each alert type carries it in its own fact. */
export function certificateIdOf(alert: AlertView): string {
    const fact = alert.alertType === SERVER_CERTIFICATE_EXPIRING ? 'serverCertificateId' : 'clientCertificateId';
    return alert.evidence?.[fact] || '';
}

/**
 * The share and the certificate a certificate alert is about, as component lines. Frontdoor sets no component on the
 * alert, so these stand in its place. Null for an alert about no share.
 */
export function certificateAlertLines(alert: AlertView): { name: string; id: string }[] | null {
    const shareId = alert.labels?.['tcpShareId'] || '';
    const shareName = alert.evidence?.['shareName'] || '';
    if (!shareId && !shareName) {
        return null;
    }
    const lines = [{ name: shareName || 'unknown', id: shareId }];
    const certificateName = alert.evidence?.['certificateName'] || '';
    const certificateId = certificateIdOf(alert);
    if (certificateName || certificateId) {
        lines.push({ name: certificateName || 'unknown', id: certificateId });
    }
    return lines;
}
